import { Form } from "antd";
import type { FC } from "react";
import { useTranslation } from "react-i18next";

import type { TerminalImportLogEntity } from "src/app/features/TerminalImportLog/types/TerminalImportLogEntity";
import { DatePickerInput } from "../../../../../components/Form/formComponents/DatePicker/DatePicker";
import type { SearchFormProps } from "../../../../../components/Form/types/types";
import { SearchForm } from "../../../../../components/SearchForm/SearchForm";

export const TerminalImportLogSearchForm: FC<SearchFormProps<TerminalImportLogEntity>> = ({ searchCallback }) => {
    const { t } = useTranslation();

    return (
        <SearchForm searchCallback={searchCallback}>
            <Form.Item label={t("form.createdFrom")} name="createdFrom">
                <DatePickerInput name="createdFrom" readOnly={false} />
            </Form.Item>
            <Form.Item label={t("form.createdTo")} name="createdTo">
                <DatePickerInput name="createdTo" readOnly={false} />
            </Form.Item>
        </SearchForm>
    );
};
